/**
 * Lazy stage registry — each stage is code-split into its own chunk.
 * Owned by the orchestrator; stage agents never need to edit this file.
 */
import type { PreviewModule, StageModule } from '@core/stage';
import type { StageId } from '@core/tree';

export const STAGE_LOADERS: Record<StageId, () => Promise<StageModule>> = {
  cell: () => import('./cell/index'),
  algae: () => import('./algae/index'),
  multicell: () => import('./multicell/index'),
  jellyfish: () => import('./jellyfish/index'),
  fish: () => import('./fish/index'),
  shark: () => import('./shark/index'),
  amphibian: () => import('./amphibian/index'),
  reptile: () => import('./reptile/index'),
  dinosaur: () => import('./dinosaur/index'),
  bird: () => import('./bird/index'),
  mammal: () => import('./mammal/index'),
  whale: () => import('./whale/index'),
  wolf: () => import('./wolf/index'),
  primate: () => import('./primate/index'),
  chimp: () => import('./chimp/index'),
  human: () => import('./human/index'),
};

export const PREVIEW_LOADERS: Record<StageId, () => Promise<PreviewModule>> = {
  cell: () => import('./cell/preview'),
  algae: () => import('./algae/preview'),
  multicell: () => import('./multicell/preview'),
  jellyfish: () => import('./jellyfish/preview'),
  fish: () => import('./fish/preview'),
  shark: () => import('./shark/preview'),
  amphibian: () => import('./amphibian/preview'),
  reptile: () => import('./reptile/preview'),
  dinosaur: () => import('./dinosaur/preview'),
  bird: () => import('./bird/preview'),
  mammal: () => import('./mammal/preview'),
  whale: () => import('./whale/preview'),
  wolf: () => import('./wolf/preview'),
  primate: () => import('./primate/preview'),
  chimp: () => import('./chimp/preview'),
  human: () => import('./human/preview'),
};
